import { Component, OnInit, Input,Output, EventEmitter ,HostListener} from '@angular/core';
import { LeftAsideService } from './left-aside.service';
import { AppDataServiceService } from '../app-data-service.service';

import {interval} from "rxjs/internal/observable/interval";
import {startWith, switchMap} from "rxjs/operators";
import { LeftThoughRightService } from './left-though-right.service';
import { string } from '@amcharts/amcharts4/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';


@Component({
  selector: 'app-left-aside',
  templateUrl: './leftAside.component.html',
  styleUrls: ['./leftAside.component.css']
})
export class LeftAsideComponent implements OnInit {
 public  leftAsideData:any ;
 public liveGridData:any ;
 public secletd_left_Aside:any ;
 public time:any ;
 public data:any ;
public DateGroup:any ;
 
 @Output() 
 showCatDataFlag:EventEmitter<boolean> =  new EventEmitter<boolean>(); 
  private globalDate  =   new BehaviorSubject<string>("2019-10-16");
  getdate = this.globalDate.asObservable();

  /*changeDate(date:string){
    this.globalDate.next(date);
  }
*/

  /** pass ref Constructor**/
  constructor(
    private _getLivData:AppDataServiceService,
    private _getEnergyAllChartDatas:LeftThoughRightService,
    private categoryData:LeftAsideService,
    private date:AppDataServiceService )
   { }
  
  ngOnInit() {
    
   //this.getLiveData();
   //console.log(this.leftAsideData);
    interval(30000)
      .pipe(
        startWith(0),
        switchMap(() => this._getLivData.getLiveData())
      )
      .subscribe(data=>this.setAllLiveData(data), res => this.categoryData.setliveData(res))
    ;
/*
    interval(5000)
      .pipe(
        startWith(0),
        switchMap(() => this.setAllLiveData)
      )
      .subscribe(res => this.categoryData.setliveData(res))
    ;*/

  }
  
  showCatData(left_Aside){
     this.showCatDataFlag.emit(false);
     this.secletd_left_Aside = left_Aside;
     this.categoryData.callComponentMethod(
          {
            data:left_Aside,
            type:'energy'
        });
           this._getEnergyAllChartDatas.getEnergyAllChartData(this.data,this.DateGroup).subscribe(
          //data=> this.setAllLiveData(data),
            error=>console.error(error)
         );
     
  }

  getLiveData(){

    console.log('hello'); 
    this._getLivData.getLiveData().subscribe(
      data=> this.setAllLiveData(data),
      error=>console.error(error)
     );
     
  }
  setAllLiveData(data){
    this.setDate(data['data']['date']);
   console.log('data');
   
   /*this._getLivData.setCurrentDate(data['data']['date']).subscribe(
      error=>console.error(error)
     );
     */
    this.DateGroup = data['data']['date'];
    this.categoryData.setHeaderDataMethod(data);
    this.time = data.data.time;
    this.setGridData(data.data.total[0]);
    this.setGroupData(data.data.group);
  }

  setDate(date){
 
    this.date.getCurrentDate(date);
}
   
  setGridData(data){
    this.liveGridData = data;
  }
  setGroupData(data){
    this.leftAsideData = data;
  }
}


